module.exports = __webpack_public_path__ + "img/img-claim.9ee437f4.png";